/**
 * Global array containing alle tracked elements
 */
const trackList = [];

const isServer = typeof window === 'undefined';

const $window = isServer ? {} : window;

export {
	trackList,
	isServer,
	$window,
};



// WEBPACK FOOTER //
// ./scripts/sky-scroll/factories/globals.js